import { createSignal, createResource, For, Show } from 'solid-js';
import TimeInput24 from '../components/TimeInput24.jsx';

// Organisasi — department + position MASTERS, code-keyed (the stable "flag",
// migration 018 / PROJECT_NOTES §4b). The code is immutable and is what the
// engine joins on; the name is cosmetic. Departments expose the attendance work
// schedule + shifts; positions expose the approval level + JenisKaryawan flag.

async function getJSON(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error('HTTP ' + res.status);
  return res.json();
}
async function postJSON(url, body) {
  const res = await fetch(url, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
  });
  return { ok: res.ok, data: await res.json().catch(() => ({})) };
}

const LEVEL_BADGE = { Direksi: 'success', Manager: 'warning', Supervisor: 'info', NonManagerial: '' };

export default function Organisasi() {
  const [tab, setTab] = createSignal('departemen');
  return (
    <>
      <div class="page-head">
        <h2>Organisasi</h2>
        <div class="spacer" />
        <div class="seg">
          <button class="seg-item" classList={{ active: tab() === 'departemen' }} onClick={() => setTab('departemen')}>Departemen</button>
          <button class="seg-item" classList={{ active: tab() === 'posisi' }} onClick={() => setTab('posisi')}>Posisi</button>
          <button class="seg-item" classList={{ active: tab() === 'divisi' }} onClick={() => setTab('divisi')}>Divisi</button>
          <button class="seg-item" classList={{ active: tab() === 'shift' }} onClick={() => setTab('shift')}>Shift</button>
        </div>
      </div>
      <Show when={tab() === 'departemen'}><DepartemenTab /></Show>
      <Show when={tab() === 'posisi'}><PosisiTab /></Show>
      <Show when={tab() === 'divisi'}><DivisiTab /></Show>
      <Show when={tab() === 'shift'}><ShiftTab /></Show>
    </>
  );
}

function ShiftTab() {
  const [list, { refetch }] = createResource(() => getJSON('/api/shifts'));
  const [depts] = createResource(() => getJSON('/api/departments').catch(() => []));
  const [form, setForm] = createSignal(null);
  const [msg, setMsg] = createSignal(null);

  function newShift() {
    setForm({ code: '', departmentCode: '', name: '', kind: 'Pagi', masuk: '07:00', pulang: '16:00', grace: 15, active: true, isNew: true });
    setMsg(null);
  }
  function editShift(sh) {
    setForm({ code: sh.code, departmentCode: sh.departmentCode || '', name: sh.name || '', kind: sh.kind || 'Pagi', masuk: sh.masuk, pulang: sh.pulang, grace: sh.grace, active: sh.active, isNew: false });
    setMsg(null);
  }
  async function save() {
    const f = form();
    const r = await postJSON('/api/shift', {
      code: f.code, departmentCode: f.departmentCode, name: f.name, kind: f.kind,
      masuk: f.masuk, pulang: f.pulang, grace: Number(f.grace) || 15, active: f.active,
    });
    if (r.ok) { setMsg({ ok: true, t: `Shift ${f.code} tersimpan.` }); setForm(null); refetch(); }
    else setMsg({ ok: false, t: r.data.error });
  }
  async function del(sh) {
    if (!confirm(`Hapus shift ${sh.code}?`)) return;
    const res = await fetch(`/api/shift?code=${encodeURIComponent(sh.code)}`, { method: 'DELETE' });
    if (res.ok) { setMsg({ ok: true, t: `Shift ${sh.code} dihapus.` }); refetch(); }
    else { const d = await res.json().catch(() => ({})); setMsg({ ok: false, t: d.error }); }
  }

  return (
    <div class="card card-pad">
      <div class="ky-vars-head">
        <p class="ky-vars-note" style="margin:0;max-width:680px">
          Shift kerja untuk departemen rolling (mis. Gudang/TKBM). Setiap hari kerja
          diklasifikasikan otomatis ke shift terdekat dari jam scan. <b>Jenis</b> menandai
          waktu shift — <b>Pagi/Siang</b> dihitung sebagai shift siang, <b>Sore/Malam</b>
          sebagai shift malam. Ini yang dipakai perhitungan gaji, bukan kode shift.
          <b>Pulang lebih awal dari masuk</b> berarti shift melewati tengah malam
          (mis. MALAM 18:30 → 03:30).
        </p>
        <div class="spacer" />
        <button class="btn primary" onClick={newShift}>+ Shift</button>
      </div>
      <Show when={msg()}><div class={`kg-verdict ${msg().ok ? 'ok' : 'fail'}`} style="margin:8px 0">{msg().t}</div></Show>
      <Show when={form()}>
        <div class="org-form">
          <div class="ky-approval-row">
            <label class="kg-field"><span>Kode {form().isNew ? '' : '(tetap)'}</span>
              <input type="text" value={form().code} disabled={!form().isNew} placeholder="mis. PAGI-GD"
                onInput={(e) => setForm({ ...form(), code: e.currentTarget.value })} /></label>
            <label class="kg-field"><span>Departemen</span>
              <select class="kg-select" value={form().departmentCode} onInput={(e) => setForm({ ...form(), departmentCode: e.currentTarget.value })}>
                <option value="">— semua —</option>
                <For each={depts() ?? []}>{(d) => <option value={d.code}>{d.code} · {d.name}</option>}</For>
              </select></label>
            <label class="kg-field kg-field-grow"><span>Nama</span>
              <input type="text" value={form().name} onInput={(e) => setForm({ ...form(), name: e.currentTarget.value })} /></label>
            <label class="kg-field"><span>Jenis</span>
              <select class="kg-select" value={form().kind} onInput={(e) => setForm({ ...form(), kind: e.currentTarget.value })}>
                <option value="Pagi">Pagi</option>
                <option value="Siang">Siang</option>
                <option value="Sore">Sore</option>
                <option value="Malam">Malam</option>
              </select></label>
            <label class="kg-field"><span>Masuk</span>
              <TimeInput24 value={form().masuk} onChange={(v) => setForm({ ...form(), masuk: v })} /></label>
            <label class="kg-field"><span>Pulang</span>
              <TimeInput24 value={form().pulang} onChange={(v) => setForm({ ...form(), pulang: v })} /></label>
            <label class="kg-field"><span>Toleransi (mnt)</span>
              <input type="number" min="0" max="240" value={form().grace} onInput={(e) => setForm({ ...form(), grace: e.currentTarget.value })} /></label>
            <label class="ky-check"><input type="checkbox" checked={form().active} onInput={(e) => setForm({ ...form(), active: e.currentTarget.checked })} /> aktif</label>
            <button class="btn primary" onClick={save}>Simpan</button>
            <button class="btn ghost" onClick={() => setForm(null)}>Batal</button>
          </div>
        </div>
      </Show>
      <table class="data">
        <thead><tr><th>Kode</th><th>Departemen</th><th>Nama</th><th>Jenis</th><th>Jam</th><th class="num">Toleransi</th><th></th></tr></thead>
        <tbody>
          <For each={list() ?? []}>{(sh) =>
            <tr classList={{ inactive: !sh.active }}>
              <td><b>{sh.code}</b></td>
              <td>{sh.department || <span class="vg-dim">semua</span>}</td>
              <td>{sh.name || <span class="vg-dim">—</span>}</td>
              <td><span class={`badge ${sh.kind === 'Sore' || sh.kind === 'Malam' ? 'warn' : 'info'}`}>{sh.kind || 'Pagi'}</span></td>
              <td>{sh.masuk}–{sh.pulang}<Show when={sh.overnight}> <span class="badge info">lewat tengah malam</span></Show></td>
              <td class="num">{sh.grace}m</td>
              <td class="num"><span class="org-actions">
                <button class="btn ghost" onClick={() => editShift(sh)}>edit</button>
                <button class="btn ghost" onClick={() => del(sh)}>hapus</button>
              </span></td>
            </tr>
          }</For>
        </tbody>
      </table>
      <Show when={list() && list().length === 0}><p class="kg-meta-text">Belum ada shift untuk perusahaan ini.</p></Show>
    </div>
  );
}

function DivisiTab() {
  const [list, { refetch }] = createResource(() => getJSON('/api/divisions'));
  const [form, setForm] = createSignal(null);
  const [msg, setMsg] = createSignal(null);

  function newDiv() { setForm({ code: '', name: '', active: true, isNew: true }); setMsg(null); }
  function editDiv(d) { setForm({ code: d.code, name: d.name, active: d.active, isNew: false }); setMsg(null); }
  async function save() {
    const f = form();
    const r = await postJSON('/api/division', { code: f.code, name: f.name, active: f.active });
    if (r.ok) { setMsg({ ok: true, t: `Divisi ${f.code} tersimpan.` }); setForm(null); refetch(); }
    else setMsg({ ok: false, t: r.data.error });
  }
  async function del(d) {
    if (!confirm(`Hapus divisi ${d.code} — ${d.name}?`)) return;
    const res = await fetch(`/api/division?code=${encodeURIComponent(d.code)}`, { method: 'DELETE' });
    if (res.ok) { setMsg({ ok: true, t: `Divisi ${d.code} dihapus.` }); refetch(); }
    else { const dd = await res.json().catch(() => ({})); setMsg({ ok: false, t: dd.error }); }
  }

  return (
    <div class="card card-pad">
      <div class="ky-vars-head">
        <p class="ky-vars-note" style="margin:0;max-width:680px">
          Divisi = unit usaha (entitas grup Metalindo) tempat karyawan bernaung —
          mis. Head Office, Besi Baja, Mega Karya, Grametindo, cabang Jember. <b>Kode</b>
          tetap (dipakai sebagai penanda); nama boleh diganti. Daftar per perusahaan.
        </p>
        <div class="spacer" />
        <button class="btn primary" onClick={newDiv}>+ Divisi</button>
      </div>
      <Show when={msg()}><div class={`kg-verdict ${msg().ok ? 'ok' : 'fail'}`} style="margin:8px 0">{msg().t}</div></Show>
      <Show when={form()}>
        <div class="org-form">
          <div class="ky-approval-row">
            <label class="kg-field"><span>Kode {form().isNew ? '' : '(tetap)'}</span>
              <input type="text" value={form().code} disabled={!form().isNew} placeholder="mis. 002"
                onInput={(e) => setForm({ ...form(), code: e.currentTarget.value })} /></label>
            <label class="kg-field kg-field-grow"><span>Nama</span>
              <input type="text" value={form().name} onInput={(e) => setForm({ ...form(), name: e.currentTarget.value })} /></label>
            <label class="ky-check"><input type="checkbox" checked={form().active} onInput={(e) => setForm({ ...form(), active: e.currentTarget.checked })} /> aktif</label>
            <button class="btn primary" onClick={save}>Simpan</button>
            <button class="btn ghost" onClick={() => setForm(null)}>Batal</button>
          </div>
        </div>
      </Show>
      <table class="data">
        <thead><tr><th>Kode</th><th>Nama</th><th class="num">Karyawan</th><th></th></tr></thead>
        <tbody>
          <For each={list() ?? []}>{(d) =>
            <tr classList={{ inactive: !d.active }}>
              <td><b>{d.code}</b></td>
              <td>{d.name}</td>
              <td class="num">{d.employeeCount}</td>
              <td class="num"><span class="org-actions">
                <button class="btn ghost" onClick={() => editDiv(d)}>edit</button>
                <button class="btn ghost" onClick={() => del(d)}>hapus</button>
              </span></td>
            </tr>
          }</For>
        </tbody>
      </table>
      <Show when={list() && list().length === 0}><p class="kg-meta-text">Belum ada divisi untuk perusahaan ini.</p></Show>
    </div>
  );
}

function DepartemenTab() {
  const [list, { refetch }] = createResource(() => getJSON('/api/departments'));
  const [schemes] = createResource(() => getJSON('/api/schemes').catch(() => []));
  const [form, setForm] = createSignal(null);  // master create/edit
  const [sched, setSched] = createSignal(null); // inline schedule edit {name,masuk,pulang,grace}
  const [msg, setMsg] = createSignal(null);
  const schemeCodes = () => (schemes() ?? []).map((s) => s.code).filter(Boolean);

  function newDept() {
    setForm({ code: '', name: '', schemeCode: '', scheduleType: 'NonShift', periodType: 'Bulanan', allowLembur: true, active: true, isNew: true });
    setSched(null); setMsg(null);
  }
  function editDept(d) {
    setForm({ code: d.code, name: d.name, schemeCode: d.schemeCode || '', scheduleType: d.scheduleType, periodType: d.periodType, allowLembur: d.allowLembur, active: d.active, isNew: false });
    setSched(null); setMsg(null);
  }
  async function saveDept() {
    const f = form();
    const r = await postJSON('/api/department', {
      code: f.code, name: f.name, schemeCode: f.schemeCode,
      scheduleType: f.scheduleType, periodType: f.periodType, allowLembur: f.allowLembur, active: f.active,
    });
    if (r.ok) { setMsg({ ok: true, t: `Departemen ${f.code} tersimpan.` }); setForm(null); refetch(); }
    else setMsg({ ok: false, t: r.data.error });
  }
  async function saveSched() {
    const e = sched();
    const r = await postJSON('/api/department/schedule',
      { department: e.name, masuk: e.masuk, pulang: e.pulang, grace: Number(e.grace) || 0 });
    if (r.ok) { setMsg({ ok: true, t: `Jadwal ${e.name} tersimpan.` }); setSched(null); refetch(); }
    else setMsg({ ok: false, t: r.data.error });
  }

  return (
    <div class="card card-pad">
      <div class="ky-vars-head">
        <p class="ky-vars-note" style="margin:0;max-width:680px">
          Daftar departemen. Tiap departemen punya <b>kode</b> tetap yang dipakai perhitungan
          (jadwal absensi, skema gaji) — nama boleh diganti kapan saja tanpa memengaruhi apa pun.
          Jadwal kerja menentukan batas terlambat (jam masuk + toleransi); untuk departemen
          dengan shift bergilir, shift tiap karyawan ditentukan otomatis dari jam scan-nya.
        </p>
        <div class="spacer" />
        <button class="btn primary" onClick={newDept}>+ Departemen</button>
      </div>

      <Show when={msg()}><div class={`kg-verdict ${msg().ok ? 'ok' : 'fail'}`} style="margin:8px 0">{msg().t}</div></Show>

      <Show when={form()}>
        <div class="org-form">
          <div class="ky-approval-row">
            <label class="kg-field"><span>Kode {form().isNew ? '' : '(tetap)'}</span>
              <input type="text" value={form().code} disabled={!form().isNew} placeholder="mis. 010"
                onInput={(e) => setForm({ ...form(), code: e.currentTarget.value })} />
            </label>
            <label class="kg-field kg-field-grow"><span>Nama</span>
              <input type="text" value={form().name} onInput={(e) => setForm({ ...form(), name: e.currentTarget.value })} />
            </label>
            <label class="kg-field"><span>Skema gaji</span>
              <select class="kg-select" value={form().schemeCode} onInput={(e) => setForm({ ...form(), schemeCode: e.currentTarget.value })}>
                <option value="">— tidak ada —</option>
                <For each={schemeCodes()}>{(c) => <option value={c}>{c}</option>}</For>
              </select>
            </label>
            <label class="kg-field"><span>Tipe jadwal</span>
              <select class="kg-select" value={form().scheduleType} onInput={(e) => setForm({ ...form(), scheduleType: e.currentTarget.value })}>
                <option value="NonShift">NonShift</option>
                <option value="FixedShift">FixedShift</option>
                <option value="RollingShift">RollingShift</option>
              </select>
            </label>
            <label class="kg-field"><span>Periode</span>
              <select class="kg-select" value={form().periodType} onInput={(e) => setForm({ ...form(), periodType: e.currentTarget.value })}>
                <option value="Bulanan">Bulanan</option>
                <option value="Mingguan">Mingguan</option>
              </select>
            </label>
            <label class="ky-check" title="Jika dimatikan, karyawan di departemen ini tidak boleh mengajukan/diberi lembur (kecuali diatur per karyawan)."><input type="checkbox" checked={form().allowLembur} onInput={(e) => setForm({ ...form(), allowLembur: e.currentTarget.checked })} /> boleh lembur</label>
            <label class="ky-check"><input type="checkbox" checked={form().active} onInput={(e) => setForm({ ...form(), active: e.currentTarget.checked })} /> aktif</label>
            <button class="btn primary" onClick={saveDept}>Simpan</button>
            <button class="btn ghost" onClick={() => setForm(null)}>Batal</button>
          </div>
        </div>
      </Show>

      <table class="data">
        <thead>
          <tr><th>Kode</th><th>Nama</th><th>Skema</th><th>Tipe jadwal</th><th class="num">Karyawan</th><th>Jadwal kerja</th><th>Shift</th><th></th></tr>
        </thead>
        <tbody>
          <For each={list() ?? []}>{(d) =>
            <tr classList={{ inactive: !d.active }}>
              <td><b>{d.code}</b></td>
              <td>{d.name}<Show when={!d.allowLembur}> <span class="badge danger" title="Karyawan di departemen ini tidak boleh lembur (kecuali diatur per karyawan)">tanpa lembur</span></Show></td>
              <td><Show when={d.schemeCode} fallback={<span class="vg-dim">—</span>}>{d.schemeCode}</Show></td>
              <td><span class="badge info">{d.scheduleType}</span></td>
              <td class="num">{d.employeeCount}</td>
              <td>
                <Show when={sched()?.name === d.name} fallback={
                  <Show when={d.hasSchedule} fallback={<span class="vg-dim">default 07:00–16:00</span>}>
                    {d.masuk}–{d.pulang} <span class="kg-meta-text">toleransi {d.grace}m</span>
                  </Show>
                }>
                  <span class="org-sched-edit">
                    <TimeInput24 value={sched().masuk} onChange={(v) => setSched({ ...sched(), masuk: v })} />
                    <TimeInput24 value={sched().pulang} onChange={(v) => setSched({ ...sched(), pulang: v })} />
                    <input type="number" min="0" max="240" class="org-grace" title="toleransi (menit)"
                      value={sched().grace} onInput={(e) => setSched({ ...sched(), grace: e.currentTarget.value })} />
                    <button class="btn primary" onClick={saveSched}>Simpan</button>
                    <button class="btn ghost" onClick={() => setSched(null)}>Batal</button>
                  </span>
                </Show>
              </td>
              <td>
                <For each={d.shifts}>{(sh) =>
                  <span class="badge info org-shift" title={`${sh.masuk}–${sh.pulang}${sh.overnight ? ' (lewat tengah malam)' : ''}`}>{sh.code}</span>
                }</For>
                <Show when={d.shifts.length === 0}><span class="vg-dim">—</span></Show>
              </td>
              <td class="num">
                <span class="org-actions">
                  <button class="btn ghost" onClick={() => editDept(d)}>edit</button>
                  <button class="btn ghost" onClick={() => setSched({ name: d.name, masuk: d.masuk || '07:00', pulang: d.pulang || '16:00', grace: d.grace || 5 })}>jadwal</button>
                </span>
              </td>
            </tr>
          }</For>
        </tbody>
      </table>
      <Show when={list() && list().length === 0}>
        <p class="kg-meta-text">Belum ada departemen. Jalankan <code>importlegacy</code> untuk mengisi dari sistem lama, atau tambah manual.</p>
      </Show>
    </div>
  );
}

function PosisiTab() {
  const [list, { refetch }] = createResource(() => getJSON('/api/positions'));
  const [schemes] = createResource(() => getJSON('/api/schemes').catch(() => []));
  const [form, setForm] = createSignal(null);
  const [msg, setMsg] = createSignal(null);
  const schemeCodes = () => (schemes() ?? []).map((s) => s.code).filter(Boolean);

  function newPos() {
    setForm({ code: '', name: '', level: 'NonManagerial', schemeCode: '', workMode: 'SingleRole', workModeCode: '', active: true, isNew: true });
    setMsg(null);
  }
  function editPos(p) {
    setForm({ code: p.code, name: p.name, level: p.level, schemeCode: p.schemeCode || '', workMode: p.workMode, workModeCode: p.workModeCode || '', active: p.active, isNew: false });
    setMsg(null);
  }
  async function savePos() {
    const f = form();
    const r = await postJSON('/api/position', {
      code: f.code, name: f.name, level: f.level, schemeCode: f.schemeCode,
      workMode: f.workMode, workModeCode: f.workModeCode, active: f.active,
    });
    if (r.ok) { setMsg({ ok: true, t: `Posisi ${f.code} tersimpan.` }); setForm(null); refetch(); }
    else setMsg({ ok: false, t: r.data.error });
  }

  return (
    <div class="card card-pad">
      <div class="ky-vars-head">
        <p class="ky-vars-note" style="margin:0;max-width:680px">
          Daftar posisi/jabatan. Tiap posisi punya <b>kode</b> tetap. <b>Level</b> menentukan
          jalur persetujuan (Direksi / Manager / Supervisor / NonManagerial). <b>Jenis Karyawan</b>
          (mis. TKBM) dipakai skema gaji TKBM untuk membedakan upah per jenis pekerja.
        </p>
        <div class="spacer" />
        <button class="btn primary" onClick={newPos}>+ Posisi</button>
      </div>

      <Show when={msg()}><div class={`kg-verdict ${msg().ok ? 'ok' : 'fail'}`} style="margin:8px 0">{msg().t}</div></Show>

      <Show when={form()}>
        <div class="org-form">
          <div class="ky-approval-row">
            <label class="kg-field"><span>Kode {form().isNew ? '' : '(tetap)'}</span>
              <input type="text" value={form().code} disabled={!form().isNew} placeholder="mis. 012"
                onInput={(e) => setForm({ ...form(), code: e.currentTarget.value })} />
            </label>
            <label class="kg-field kg-field-grow"><span>Nama</span>
              <input type="text" value={form().name} onInput={(e) => setForm({ ...form(), name: e.currentTarget.value })} />
            </label>
            <label class="kg-field"><span>Level (persetujuan)</span>
              <select class="kg-select" value={form().level} onInput={(e) => setForm({ ...form(), level: e.currentTarget.value })}>
                <option value="Direksi">Direksi</option>
                <option value="Manager">Manager</option>
                <option value="Supervisor">Supervisor</option>
                <option value="NonManagerial">NonManagerial</option>
              </select>
            </label>
            <label class="kg-field"><span>Skema gaji</span>
              <select class="kg-select" value={form().schemeCode} onInput={(e) => setForm({ ...form(), schemeCode: e.currentTarget.value })}>
                <option value="">— tidak ada —</option>
                <For each={schemeCodes()}>{(c) => <option value={c}>{c}</option>}</For>
              </select>
            </label>
            <label class="kg-field"><span>Mode kerja</span>
              <select class="kg-select" value={form().workMode} onInput={(e) => setForm({ ...form(), workMode: e.currentTarget.value })}>
                <option value="SingleRole">SingleRole</option>
                <option value="MultiRole">MultiRole</option>
              </select>
            </label>
            <label class="kg-field"><span>JenisKaryawan (kode)</span>
              <input type="text" value={form().workModeCode} placeholder="mis. TKBM"
                onInput={(e) => setForm({ ...form(), workModeCode: e.currentTarget.value })} />
            </label>
            <label class="ky-check"><input type="checkbox" checked={form().active} onInput={(e) => setForm({ ...form(), active: e.currentTarget.checked })} /> aktif</label>
            <button class="btn primary" onClick={savePos}>Simpan</button>
            <button class="btn ghost" onClick={() => setForm(null)}>Batal</button>
          </div>
        </div>
      </Show>

      <table class="data">
        <thead>
          <tr><th>Kode</th><th>Nama</th><th>Level</th><th>Skema</th><th>JenisKaryawan</th><th class="num">Karyawan</th><th>Peran persetujuan</th><th></th></tr>
        </thead>
        <tbody>
          <For each={list() ?? []}>{(p) =>
            <tr classList={{ inactive: !p.active }}>
              <td><b>{p.code}</b></td>
              <td>{p.name}</td>
              <td><span class={`badge ${LEVEL_BADGE[p.level] ?? ''}`}>{p.level}</span></td>
              <td><Show when={p.schemeCode} fallback={<span class="vg-dim">—</span>}>{p.schemeCode}</Show></td>
              <td><Show when={p.workModeCode} fallback={<span class="vg-dim">—</span>}><span class="org-shift">{p.workModeCode}</span></Show></td>
              <td class="num">{p.employeeCount}</td>
              <td class="org-roles">
                <Show when={p.staff}><span class="badge info">{p.staff} staff</span></Show>
                <Show when={p.approver}><span class="badge warning">{p.approver} approver</span></Show>
                <Show when={p.executive}><span class="badge success">{p.executive} executive</span></Show>
                <Show when={!p.employeeCount}><span class="vg-dim">—</span></Show>
              </td>
              <td class="num"><button class="btn ghost" onClick={() => editPos(p)}>edit</button></td>
            </tr>
          }</For>
        </tbody>
      </table>
      <Show when={list() && list().length === 0}>
        <p class="kg-meta-text">Belum ada posisi. Jalankan <code>importlegacy</code> untuk mengisi dari sistem lama, atau tambah manual.</p>
      </Show>
    </div>
  );
}
